import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=2d62a0ea&scoped=true"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"
import style0 from "./newslist.vue?vue&type=style&index=0&id=2d62a0ea&prod&scoped=true&lang=css"
import style1 from "./newslist.vue?vue&type=style&index=1&id=2d62a0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62a0ea",
  null
  
)

export default component.exports